import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Helmet } from 'react-helmet';
import { useHistoryNav } from '../../hooks/useHistoryNav';

const Home = ({ user, loggedIn }) => {
	const history = useHistoryNav();

	return (
		<>
			<Helmet>
				<title>Torio Admin Portal</title>
				<meta
					name="description"
					content="Access your Torio business dashboard"
				/>
			</Helmet>

			<Box
				sx={{
					minHeight: '100vh',
					background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					padding: 2,
				}}
			>
				<Container maxWidth="sm">
					<Box
						sx={{
							backgroundColor: 'white',
							borderRadius: 4,
							padding: { xs: 4, sm: 6 },
							textAlign: 'center',
							boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
							border: '1px solid rgba(255,255,255,0.2)',
						}}
					>
						{/* Logo/Brand */}
						<Typography
							variant="h2"
							sx={{
								fontWeight: 700,
								color: '#1a1a1a',
								marginBottom: 2,
								fontSize: { xs: '2.5rem', sm: '3.5rem' },
							}}
						>
							Torio
						</Typography>

						{/* Subtitle */}
						<Typography
							variant="h5"
							sx={{
								color: '#666',
								fontWeight: 300,
								marginBottom: 4,
								fontSize: { xs: '1.2rem', sm: '1.5rem' },
							}}
						>
							Business Admin Portal
						</Typography>

						{/* Description */}
						<Typography
							variant="body1"
							sx={{
								color: '#888',
								marginBottom: 5,
								lineHeight: 1.6,
								fontSize: '1.1rem',
							}}
						>
							Access your business dashboard to manage operations, view
							analytics, and control your Torio system.
						</Typography>

						{/* Login Button */}
						<Button
							variant="contained"
							size="large"
							onClick={() => history('/login')}
							sx={{
								backgroundColor: '#667eea',
								color: 'white',
								padding: '16px 48px',
								fontSize: '1.1rem',
								fontWeight: 600,
								borderRadius: 3,
								textTransform: 'none',
								boxShadow: '0 8px 20px rgba(102, 126, 234, 0.3)',
								marginBottom: 3,
								'&:hover': {
									backgroundColor: '#5a6fd8',
									boxShadow: '0 12px 24px rgba(102, 126, 234, 0.4)',
									transform: 'translateY(-2px)',
								},
								transition: 'all 0.3s ease',
							}}
						>
							{loggedIn ? 'Go to Dashboard' : 'Sign In'}
						</Button>

						{/* Contact Link */}
						<Typography
							variant="body2"
							sx={{
								color: '#999',
								marginTop: 4,
							}}
						>
							Need access?{' '}
							<Box
								component="a"
								href="mailto:torio@torio.is?subject=Request Admin Access"
								sx={{
									color: '#667eea',
									textDecoration: 'none',
									fontWeight: 500,
									'&:hover': {
										textDecoration: 'underline',
									},
								}}
							>
								Contact us
							</Box>
						</Typography>
					</Box>
				</Container>
			</Box>
		</>
	);
};

export default Home;
